export const TEXT_LABELS = {
    COPY_RIGHT_TEXT_LABEL : "© 2026 Rapchik. All rights reserved.",

    COUNTRY_CODE_INDIA : "+91",

    // Auth Labels — Figma 18384:2638
    AUTH_LOGIN_TITLE: "Log in to Rapchik",
    AUTH_LOGIN_SUBTITLE: "Ready to play your entertainment",
    AUTH_LOGIN_HEADLINE_KHELO: "Khelo",
    AUTH_LOGIN_HEADLINE_DIL_SE: "Dil Se",
    AUTH_LOGIN_HEADLINE_JEETO: "Jeeto",
    AUTH_LOGIN_HEADLINE_DIMAAG_SE: "Dimaag Se!",
    AUTH_LOGIN_CONTINUE: "Continue to Login With",
    AUTH_LOGIN_TAB_MOBILE: "Mobile",
    AUTH_LOGIN_TAB_EMAIL: "Email",
    AUTH_COUNTRY_CODE_ARIA: "Country code",
    AUTH_INPUT_PHONE_PLACEHOLDER: "Enter Mobile Number",
    AUTH_INPUT_EMAIL_PLACEHOLDER: "Enter Email",
    AUTH_TERMS_PREFIX: "I agree to the ",
    AUTH_TERMS_LINK: "Terms & Conditions",
    AUTH_TERMS_AND: " and ",
    AUTH_PRIVACY_LINK: "Privacy Policy",
    AUTH_TERMS_ARIA: "Agree to Terms and Conditions and Privacy Policy",
    AUTH_TERMS_URL: "https://rapchik.app/terms-conditions",
    AUTH_PRIVACY_URL: "https://rapchik.app/privacy-policy",
    AUTH_INPUT_OTP_SUBTITLE: "Please enter OTP below, sent to",
    AUTH_OTP_TITLE: "Please enter OTP below, sent to",
    AUTH_OTP_CHANGE: "Change",
    AUTH_OTP_YOUR_ACCOUNT: "your account",
    AUTH_OTP_SENT: "OTP Sent",
    AUTH_OTP_MISSING_IDENTIFIER: "No email or phone number provided. Please go back and enter your details.",
    AUTH_OTP_INCOMPLETE: "Please enter the complete 6-digit OTP",
    AUTH_OTP_INVALID: "Invalid OTP. Please try again.",
    AUTH_OTP_RESEND_FAILED: "Failed to resend OTP. Please try again.",
    AUTH_ACTION_BUTTON_LOGIN: "GET OTP",
    AUTH_ACTION_BUTTON_SEND_OTP: "Sending...",
    AUTH_ACTION_BUTTON_VERIFIY_OTP: "Verifying...",
    AUTH_ACTION_BUTTON_SUBMIT_OTP: "SUBMIT",
    AUTH_ACTION_BUTTON_RESEND_OTP: "Resend OTP",

    // Game Selection Labels
    GAME_TITLE_1: "RapHousie",
    GAME_SUBTITLE_1: "Play Tambola with a twist and win exciting rewards!",
    GAME_TITLE_2: "RapLeague",
    GAME_SUBTITLE_2: "Create your league of stars!",
    GAME_TITLE_3: "RapFire",
    GAME_SUBTITLE_3: "Test your knowledge with 5 rapid questions!",
    GAME_TITLE_4: "RapWheel",
    GAME_SUBTITLE_4: "Spin and test your skills!",

    // Header Labels
    HEADER_NAV_GAME_ZONE: "Game Zone",
    HEADER_NAV_ABOUT_US: "About Us",
    HEADER_NAV_CONTACT_US: "Contact us",
    HEADER_ABOUT_US_URL: "https://rapchik.app/",
    HEADER_CONTACT_US_URL: "https://rapchik.app/contact",

    // Game - RapHousie Labels
    RAP_HOUSIE_WELCOME_TITLE: "Welcome to",
    RAP_HOUSIE_WELCOME_TITLE_BRAND: "RapHOUSIE",
    RAP_HOUSIE_WE_WORK: "RapHousie",
    //RAP_HOUSIE_WE_WORK: "WeWork RapHousie",
    RAP_HOUSIE_TIME_REMAINING: " Remaining",
    RAP_HOUSIE_ROOM_TITLE: "More Fun When You Play with Friends",
    RAP_HOUSIE_CREATE_ROOM_TITLE: "CREATE ROOM",
    RAP_HOUSIE_CREATE_ROOM_BUTTON_LABEL: "Create New Room",
    RAP_HOUSIE_CREATE_ROOM_SUBTITLE: "Host your own RapHousie game and invite friends to join your room.",

    RAP_HOUSIE_JOIN_ROOM_TITLE: "JOIN ROOM",
    RAP_HOUSIE_JOIN_ROOM_BUTTON_LABEL: "Enter the 5 digit code",
    RAP_HOUSIE_JOIN_ROOM_CODE_HINT: "Enter the 5 digit Room code",
    RAP_HOUSIE_JOIN_ROOM_PROCEED: "Proceed",
    RAP_HOUSIE_JOIN_ROOM_RESEND: "RESEND OTP",
    RAP_HOUSIE_JOIN_ROOM_SUBTITLE: "Join an existing RapHousie game room.",
    RAP_HOUSIE_JOIN_ROOM_SUBTITLE_2: "Game code Required",
    RAP_HOUSIE_BACK_TO_PREVIOUS: "Back to Previous Page",
    RAP_HOUSIE_BACK_TO_GAMES: "Back to RapGames",
    RAP_HOUSIE_HOST_PAGE_TITLE: "Host your own Room",
    RAP_HOUSIE_HOST_HERO_TITLE: "Welcome to RapHousie",
    RAP_HOUSIE_HOST_HERO_SUBTITLE:
      "Enjoy Tambola with family, friends, or colleagues—with a twist! Winners win exciting rewards!",
    RAP_HOUSIE_HOST_INVITE_LINE: "Host your own RapHousie Room & invite friends!",
    RAP_HOUSIE_YOUR_CREATED_ROOM: "YOUR CREATED ROOM",
    RAP_HOUSIE_FAMILY_ROOM_LABEL: "Family Room",

    RAP_HOUSIE_CREATED_ROOM_NO_LIST_TITLE: "No Rooms Created!",
    RAP_HOUSIE_CREATED_ROOM_NO_LIST_SUBTITLE: "Create room and keep enjoying",
    RAP_HOUSIE_WE_WORK_COMPANY_NAME: "",
    //RAP_HOUSIE_WE_WORK_COMPANY_NAME: "@WeWork India - BlueOne Gurugram",

    RAP_HOUSIE_START_GAME_BUTTON_LABEL: "Start Game",
    RAP_HOUSIE_JOIN_ROOM_ACTION_LABEL: "Join Room",
    RAP_HOUSIE_START_GAME_BUTTON_VIEW: "VIEW",

    RAP_HOUSIE_NAVIGATION_HOME: "Home",
    RAP_HOUSIE_NAVIGATION_BACK: "Back",
    RAP_HOUSIE_NAVIGATION_CREATE_ROOM: "Create New Room",

    RAP_HOUSIE_ROOM_TYPE_WELCOME_TITLE: "CREATE ROOM",
    RAP_HOUSIE_ROOM_TYPE_WELCOME_SUBTITLE: "Host your own RapHousie game and invite friends to join your room.",

    RAP_HOUSIE_ROOM_CREATE_BUTTON_LABEL: "CREATE ROOM",

    RAP_HOUSIE_FAMILY_ROOM_TITLE: "Family Room",
    RAP_HOUSIE_FAMILY_ROOM_SUBTITLE_1: "Perfect for small gatherings",
    RAP_HOUSIE_FAMILY_ROOM_SUBTITLE_2: "Enjoy quality time with friends and family!",
    RAP_HOUSIE_FAMILY_ROOM_LIMIT: "Up to 15 people",
    
    RAP_HOUSIE_KITTY_ROOM_TITLE: "Kitty Room",
    RAP_HOUSIE_KITTY_ROOM_SUBTITLE_1: "Designed for kitty groups",
    RAP_HOUSIE_KITTY_ROOM_SUBTITLE_2: "More friends, more fun, more excitement!",
    RAP_HOUSIE_KITTY_ROOM_LIMIT: "Up to 30 people",

    RAP_HOUSIE_CORPORATE_ROOM_TITLE: "Corporate Room",
    RAP_HOUSIE_CORPORATE_ROOM_SUBTITLE_1: "Ideal for large groups",
    RAP_HOUSIE_CORPORATE_ROOM_SUBTITLE_2: "Team bonding meets fun!",
    RAP_HOUSIE_CORPORATE_ROOM_LIMIT: "Support any team size",

    RAP_HPOUSIE_ROOM_NAME_WELCOME_TITLE: "Create ",
    RAP_HPOUSIE_ROOM_NAME_WELCOME_SUBTITLE: "Ready to play your entertainment",
    RAP_HPOUSIE_ROOM_NAME_INPUT_FIELD_LABEL: "Enter Room Name",
    RAP_HPOUSIE_ROOM_NAME_CREATE_BUTTON_LABEL: "CREATE ROOM",
    RAP_HOUSIE_CREATE_WAITING_HINT: "You may display any image/video on waiting screen",
    RAP_HOUSIE_CREATE_UPLOAD_TEXT: "Upload an image/video (Optional)",
    RAP_HOUSIE_CREATE_UPLOAD_HINT: "Best fit - 16:9 ratio",

    RAP_HOUSIE_ROOM_GAME_CODE_SHARE_WELCOME_TITLE: " Room Created",
    RAP_HOUSIE_ROOM_GAME_CODE_SHARE_TITLE: "Your Game Code",
    RAP_HOUSIE_ROOM_GAME_CODE_SHARE_SUBTITLE: "Share this code with others to let them join the Room",
    RAP_HOUSIE_ROOM_GAME_CODE_SHARE_HINT: "You can start the game or wait for others to join",
    RAP_HOUSIE_ROOM_GAME_CODE_SHARE_BUTTON_LABEL: "Share Code",
    RAP_HOUSIE_ROOM_GAME_CODE_SHARE_TOTAL_JOINED: "Total Joined : ",
    RAP_HOUSIE_ROOM_GAME_CODE_SHARE_JOINED_STATUS_JOIN: "Joined",
    RAP_HOUSIE_ROOM_GAME_CODE_SHARE_JOINED_STATUS_JOINING: "Joining",

    RAP_HOUSIE_ROOM_GAME_CODE_SHARE_NO_PLAYER_TITLE: "No players Yet!",
    RAP_HOUSIE_ROOM_GAME_CODE_SHARE_NO_PLAYER_SUBTITLE: "Your players will show up here once you add them.",
    RAP_HOUSIE_LOBBY_BRAND_TITLE: "RapHOUSIE",

    RAP_HOUSIE_GAME_START_TIMER_WELCOME_TITLE: "Get Ready for",
    RAP_HOUSIE_GAME_START_TIMER_WELCOME_TITLE_RAPHOUSIE: "RapHousie",
    RAP_HOUSIE_GAME_START_TIMER_WELCOME_SUBTITLE: "GAME STARTS IN",
    RAP_HOUSIE_LIVE_GAME_START_HOLD_ON: "Hey, Hold On!",
    RAP_HOUSIE_LIVE_GAME_START_TITLE: "Game Starting",

    RAP_HOUSIE_LIVE_GAME_TRIVIA_SECTION_TITLE: "TRIVIA CARD",
    RAP_HOUSIE_LIVE_GAME_TOTAL_MEMBERS_PREFIX: "TOTAL MEMBERS",
    RAP_HOUSIE_LIVE_GAME_CLAIM_STATUS_CLAIMED: "Claimed",
    RAP_HOUSIE_LIVE_GAME_CLAIM_STATUS_UNCLAIMED: "Unclaimed",

    RAP_HOUSIE_LIVE_GAME_CLAIM_TYPE_EARLY_FIVE: "Early Five",
    RAP_HOUSIE_LIVE_GAME_CLAIM_TYPE_EARLY_THREE: "Early 3",
    RAP_HOUSIE_LIVE_GAME_CLAIM_TYPE_TOP_LINE: "Top Line",
    RAP_HOUSIE_LIVE_GAME_CLAIM_TYPE_BOTTOM_LINE: "Bottom Line",
    RAP_HOUSIE_LIVE_GAME_CLAIM_TYPE_MIDDLE_LINE: "Middle Line",
    RAP_HOUSIE_LIVE_GAME_CLAIM_TYPE_FULL_HOUSE: "Full House",
    RAP_HOUSIE_LIVE_GAME_CLAIM_TYPE_FOUR_CORNERS: "Four Corners",

    RAP_HOUSIE_LIVE_GAME_PAUSE_BUTTON_LABEL: "Pause Game",
    RAP_HOUSIE_LIVE_GAME_RESUME_BUTTON_LABEL: "Resume Game",

    RAP_HOUSIE_LIVE_GAME_CALIMED_USERS_LIST_TITLE: "Claimed",

    RAP_HOUSIE_LIVE_GAME_VALIDATING_POPUP_TITLE: "Game Paused",
    RAP_HOUSIE_LIVE_GAME_VALIDATING_POPUP_SUBTITLE: "Validating user claims...",
    
    RAP_HOUSIE_LIVE_GAME_RESULT_POPUP_TITLE: "Results",
    RAP_HOUSIE_LIVE_GAME_RESULT_POPUP_SUBTITLE: " Claims",
    RAP_HOUSIE_LIVE_GAME_RESULT_POPUP_STATUS_WINNER: "WINNER",
    RAP_HOUSIE_LIVE_GAME_RESULT_POPUP_STATUS_BOGUS: "Bogus",

    RAP_HOUSIE_LIVE_GAME_CLAIM_SUCCESS_POPUP_LABEL: " Completed",

    RAP_HOUSIE_LEADERBOARD_TITLE: "Leaderboard",
    RAP_HOUSIE_LEADERBOARD_SUBTITLE: "Congratulations Winners",
    RAP_HOUSIE_LEADERBOARD_COL_RANK: "Rank",
    RAP_HOUSIE_LEADERBOARD_COL_PLAYER: "Player and Claims",
    RAP_HOUSIE_LEADERBOARD_COL_WON: "Won",
    RAP_HOUSIE_LEADERBOARD_COL_GAME_POINTS: "Game Points",
    RAP_HOUSIE_LEADERBOARD_NO_WINNERS: "No winners yet",



    RAP_FIRE_GAME_START_TIMER_WELCOME_TITLE_RAPFIRE: "RapFire",
    RAP_FIRE_WELCOME_TITLE: "Welcome to",
    RAP_FIRE_WELCOME_TITLE_BRAND: "Rapfire",
    RAP_FIRE_ROOM_TITLE: "More Fun When You Play with Friends",
    RAP_FIRE_CREATE_ROOM_TITLE: "CREATE ROOM",
    RAP_FIRE_CREATE_ROOM_SUBTITLE: "Host your own RapFire game and invite friends to join your room.",
    RAP_FIRE_JOIN_ROOM_TITLE: "JOIN ROOM",
    RAP_FIRE_JOIN_ROOM_SUBTITLE: "Join an existing RapFire game room.",
    RAP_FIRE_JOIN_ROOM_SUBTITLE_2: "Game code Required",
    RAP_FIRE_ROOM_TYPE_WELCOME_TITLE: "CREATE ROOM",
    RAP_FIRE_ROOM_TYPE_WELCOME_SUBTITLE: "Host your own RapFire game and invite friends to join your room.",
    RAP_FIRE_HOST_HERO_TITLE: "Welcome to RapFire",
    RAP_FIRE_HOST_HERO_SUBTITLE:
      "Enjoy Quiz with family, friends, or colleagues with 5 rapid questions! Winners win exciting rewards!",
    RAP_FIRE_HOST_INVITE_LINE: "Host your own RapFire Room & invite friends!",
    RAP_FIRE_YOUR_CREATED_ROOM: "YOUR CREATED ROOM",
    RAP_FIRE_ROOM_CREATE_BUTTON_LABEL: "CREATE ROOM",
    RAP_FIRE_FAMILY_ROOM_TITLE: "Family Room",
    RAP_FIRE_FAMILY_ROOM_SUBTITLE_1: "Perfect for small gatherings",
    RAP_FIRE_FAMILY_ROOM_SUBTITLE_2: "Enjoy quality time with friends and family!",
    RAP_FIRE_FAMILY_ROOM_LIMIT: "Up to 15 people",
    RAP_FIRE_KITTY_ROOM_TITLE: "Kitty Room",
    RAP_FIRE_KITTY_ROOM_SUBTITLE_1: "Designed for kitty groups",
    RAP_FIRE_KITTY_ROOM_SUBTITLE_2: "More friends, more fun, more excitement!",
    RAP_FIRE_KITTY_ROOM_LIMIT: "Up to 30 people",
    RAP_FIRE_CORPORATE_ROOM_TITLE: "Corporate Room",
    RAP_FIRE_CORPORATE_ROOM_SUBTITLE_1: "Ideal for large groups",
    RAP_FIRE_CORPORATE_ROOM_SUBTITLE_2: "Team bonding meets fun!",
    RAP_FIRE_CORPORATE_ROOM_LIMIT: "Support any team size",
    RAP_FIRE_FAMILY_ROOM_LABEL: "Family Room",
    RAP_FIRE_START_GAME_BUTTON_LABEL: "Start Game",
    RAP_FIRE_START_GAME_BUTTON_VIEW: "VIEW",
    RAP_FIRE_LOBBY_BRAND_TITLE: "RapFIRE",
    RAP_FIRE_ROOM_GAME_CODE_SHARE_WELCOME_TITLE: " Room Created",
    RAP_FIRE_ROOM_GAME_CODE_SHARE_TITLE: "Your Game Code",
    RAP_FIRE_ROOM_GAME_CODE_SHARE_SUBTITLE: "Share this code with others to let them join the Room",
    RAP_FIRE_ROOM_GAME_CODE_SHARE_HINT: "You can start the game or wait for others to join",
    RAP_FIRE_ROOM_GAME_CODE_SHARE_BUTTON_LABEL: "Share Code",
    RAP_FIRE_ROOM_GAME_CODE_SHARE_TOTAL_JOINED: "Total Joined : ",
    RAP_FIRE_ROOM_GAME_CODE_SHARE_JOINED_STATUS_JOIN: "Joined",
    RAP_FIRE_ROOM_GAME_CODE_SHARE_JOINED_STATUS_JOINING: "Joining",
    RAP_FIRE_ROOM_GAME_CODE_SHARE_NO_PLAYER_TITLE: "No players Yet!",
    RAP_FIRE_ROOM_GAME_CODE_SHARE_NO_PLAYER_SUBTITLE: "Your players will show up here once you add them.",
    RAP_FIRE_GAME_LIVE_QUESTION_NO_TITLE: "QUESTION NO",
    RAP_FIRE_GAME_LIVE_QUESTION_OF: "of",
    RAP_FIRE_CORRECT_ANSWER_TITLE: "Correct Answer",
    RAP_FIRE_LEADERBOARD_POINTS_TITLE: "Points",
    RAP_FIRE_LEADERBOARD_TITLE: "Leaderboard",
    RAP_FIRE_LEADERBOARD_SUBTITLE: "Congratulations Winners",
    RAP_FIRE_LEADERBOARD_COL_RANK: "Rank",
    RAP_FIRE_LEADERBOARD_COL_PLAYER: "Player",
    RAP_FIRE_LEADERBOARD_COL_WON: "Won",
    RAP_FIRE_LEADERBOARD_COL_GAME_POINTS: "Game Points",
    RAP_FIRE_LEADERBOARD_NO_WINNERS: "No winners yet",
    RAP_FIRE_WINNER_RANK_POSTFIX_ST: "st",
    RAP_FIRE_WINNER_RANK_POSTFIX_ND: "nd",
    RAP_FIRE_WINNER_RANK_POSTFIX_RD: "rd",
    RAP_FIRE_WINNER_RANK_POSTFIX_TH: "th",
    RAP_FIRE_LEADERBOARD_WINNER_TITLE: "winner",
    RAP_FIRE_LEADERBOARD_WINNER_WISHES: "Congratulations Winners!",

    TOURNAMENT_LEADERBOARD_TITLE: "Tournament - Leaderboard",
    TOURNAMENT_LEADERBOARD_COL_TOTAL_POINTS: "Total Points",
    TOURNAMENT_PROGRESS_TITLE: "TOURNAMENT PROGRESS",
    TOURNAMENT_PROGRESS_SUBTITLE: "Cumulative score determines the final rank",
    TOURNAMENT_STAGE_RAPFIRE: "RapFire",
    TOURNAMENT_STAGE_RAPHOUSIE: "RapHousie",
    TOURNAMENT_STAGE_QUESTION: "QUESTION",
    TOURNAMENT_STAGE_COMPLETED: "COMPLETED",
    TOURNAMENT_STAGE_NEXT: "NEXT",
    TOURNAMENT_STAGE_UP_NEXT: "UP NEXT",
    TOURNAMENT_STAGE_LIVE: "LIVE",
    TOURNAMENT_LEADERBOARD_NO_WINNERS: "No winners yet",
    TOURNAMENT_LEADERBOARD_WINNER_WISHES: "Congratulations Winners!",
    TOURNAMENT_WINNER_PRIZES_EYEBROW: "TOURNAMENT",
    TOURNAMENT_WINNER_PRIZES_TITLE: "WINNER PRIZES",
    TOURNAMENT_WINNER_PRIZES_SUBTITLE: "Top performers take home the biggest rewards!",
    TOURNAMENT_WINNER_PRIZES_CHAMPION: "CHAMPION",
    TOURNAMENT_WINNER_PRIZES_RIBBON: "{place} Prize",
    TOURNAMENT_WINNER_PRIZES_PLACE: "#{rank} on the final leaderboard",

    // Notifications
    NOTIFICATION_LIST_TITLE: "Notifications",
    NOTIFICATION_LIST_COUNT_ZERO: "0 notifications",
    NOTIFICATION_LIST_EMPTY_TITLE: "No notifications yet",
    NOTIFICATION_LIST_EMPTY_SUBTITLE: "When you get updates, they will show up here.",
    NOTIFICATION_LIST_ERROR: "Could not load notifications. Please try again.",
    NOTIFICATION_LIST_RETRY: "Retry",
    NOTIFICATION_LIST_LOADING: "Loading notifications…",
    NOTIFICATION_LIST_UNREAD: "New",

    // Logout confirmation — Home Screen
    LOGOUT_CONFIRM_TITLE: "Logout",
    LOGOUT_CONFIRM_MESSAGE: "Are you sure you want to logout?",
    LOGOUT_CONFIRM_CANCEL: "Cancel",
    LOGOUT_CONFIRM_ACTION: "Logout",
};